import base from "@/fstore";
import validation from "@/fstore/validation";
import moment from 'moment';

const db = base.db;
const collection = "siteDocuments";
const model = db.collection(collection);

export const PrivacyPolicy = {
  get: async () => {
    const doc = await model.doc('privacyPolicy').get();

    const policy = doc.data();

    return policy;
  },

  set: async (policy) => {
    policy.modified = new Date();

    return await model.doc('privacyPolicy').set({ ...policy })
  }
}

export const TermsAndConditions = {
  get: async () => {
    const doc = await model.doc('termsAndConditions').get();
    const terms = doc.data();

    return terms;
  },
  set: async (terms) => {
    terms.modified = new Date();
    return await model.doc('termsAndConditions').set({ ...terms })
  }
}